import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import api, { fileUrl } from "@/lib/api";
import { Calendar, User, ArrowLeft, Tag } from "lucide-react";
import { ArticleCard } from "@/components/ArticleCard";

export default function ArticleDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [article, setArticle] = useState(null);
  const [related, setRelated] = useState([]);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get(`/articles/${id}`).then((res) => {
      setArticle(res.data);
      api.get("/articles").then((r) => {
        setRelated(r.data.filter((a) => a.id !== id && a.category === res.data.category).slice(0, 3));
      });
    }).catch(() => setNotFound(true));
  }, [id]);

  if (notFound) return (
    <div className="max-w-3xl mx-auto px-4 py-32 text-center">
      <p className="text-slate-500 text-lg">लेख नहीं मिला।</p>
      <Link to="/articles" className="text-amber-700 mt-4 inline-block">← सभी लेख</Link>
    </div>
  );

  if (!article) return <div className="py-32 text-center text-slate-400">लोड हो रहा है...</div>;

  return (
    <div>
      <article className="max-w-3xl mx-auto px-4 sm:px-6 py-14">
        <button onClick={() => navigate("/articles")} data-testid="article-back-button" className="flex items-center gap-2 text-amber-700 mb-6 hover:underline">
          <ArrowLeft size={18} /> सभी लेख
        </button>
        <div className="flex flex-wrap items-center gap-4 text-sm text-slate-500 mb-4">
          {article.category && <span className="flex items-center gap-1 bg-amber-50 text-amber-700 px-3 py-1 rounded-full"><Tag size={13} /> {article.category}</span>}
          {article.author && <span className="flex items-center gap-1"><User size={14} /> {article.author}</span>}
          {article.date && <span className="flex items-center gap-1"><Calendar size={14} /> {article.date}</span>}
        </div>
        <h1 className="font-display text-3xl sm:text-4xl text-[#0a2540] leading-tight mb-6">{article.title}</h1>
        {article.image_url && (
          <img src={fileUrl(article.image_url)} alt={article.title} className="w-full rounded-xl mb-8 shadow-md" />
        )}
        {article.summary && <p className="prose-deva text-slate-700 font-medium border-l-4 border-amber-500 pl-4 mb-6 italic">{article.summary}</p>}
        {article.is_html ? (
          <div className="prose-deva blog-content text-slate-700" dangerouslySetInnerHTML={{ __html: article.content }} />
        ) : (
          <div className="prose-deva text-slate-700 whitespace-pre-wrap">{article.content}</div>
        )}
      </article>

      {related.length > 0 && (
        <section className="bg-white border-t border-amber-200/50 py-14">
          <div className="max-w-7xl mx-auto px-4 sm:px-6">
            <h2 className="font-display text-2xl sm:text-3xl text-[#0a2540] mb-8">संबंधित लेख</h2>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {related.map((a) => <ArticleCard key={a.id} article={a} />)}
            </div>
          </div>
        </section>
      )}
    </div>
  );
}
